import * as React from 'react'
import Responsive from 'react-responsive'

export const RWD = {
  Desktop: props => <Responsive {...props} minWidth={992} />,
  Tablet: props => <Responsive {...props} minWidth={576} maxWidth={991} />,
  Mobile: props => <Responsive {...props} maxWidth={575} />,
  Default: props => <Responsive {...props} minWidth={576} />
}



// WEBPACK FOOTER //
// ./src/elements/RWD.tsx